import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/components/color-legend.css';

const ColorLegend = ({ items, visible = true, className = '', orientation = 'horizontal' }) => {
  if (!visible || !items || items.length === 0) return null;

  return (
    <div className={`color-legend color-legend-${orientation} ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="color-legend-item">
          <div
            className="color-legend-dot"
            style={{ backgroundColor: item.color }}
          />
          <span className="color-legend-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

ColorLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ).isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};

export default ColorLegend;